// DatadogRumSectionBoundary.tsx
import { datadogRum } from "@datadog/browser-rum";
import { ErrorBoundary } from "@datadog/browser-rum-react";
import { Outlet, useLocation } from "react-router-dom";

import { useEffect, useState } from "react";

import { normalizeViewName } from "./rum-privacy";
import { getRumConfig, isRumEnabled } from "./rum.config";

export function DatadogRumSectionBoundary(): JSX.Element {
  const location = useLocation();
  const [rumInitializedState, setRumInitializedState] = useState(false);

  useEffect(() => {
    if (!isRumEnabled()) {
      console.warn(`[RUM] RUM is not enabled for the current environment: ${process.env.APP_ENV}`);
      return;
    }
    if (rumInitializedState) {
      return;
    }

    datadogRum.init(getRumConfig());
    datadogRum.startSessionReplayRecording();
    setRumInitializedState(true);
  }, [rumInitializedState]);

  useEffect(() => {
    if (!isRumEnabled() || !rumInitializedState) {
      return;
    }
    const viewName = normalizeViewName(location.pathname);
    if (viewName) {
      datadogRum.startView({ name: viewName });
    }
  }, [rumInitializedState, location.pathname]);

  return (
    <ErrorBoundary
      fallback={({ error, resetError }) => (
        <div>
          <p>Something went wrong.</p>
          <button onClick={resetError}>Try again</button>
        </div>
      )}
    >
      <Outlet />
    </ErrorBoundary>
  );
}
